import styled from '@emotion/styled';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import { Trap } from 'src/domains/sportsbook/webview/components/trap/Trap';

export const WidgetTrapBox = styled(Trap, { label: 'WidgetTrapBox' })`
    flex: 0 0 32px;
    padding: 4px;
    width: 32px;
`;

export const WidgetSilkBox = styled(LazyImageSilk, { label: 'WidgetSilkBox' })`
    flex: 0 0 36px;
    height: 100%;
    width: 36px;
`;
